//* Import libraries
import { useState, useCallback, useEffect } from "react";

//* Import react-router hooks
import { Link, useNavigate } from "react-router-dom";

//* Import components
import { List } from "../../../component/list/list";
import { Loading } from "../../../component/common/Loading";

//* Import custom hooks
import { useDemands } from "../../../hooks/demand/useDemands";

import { Demands } from "../../../hooks/demand/types/types";
import { Button, Form, Spinner, Row, Col } from "react-bootstrap";
import { Attention } from "../../../component/base/Attention";
import ModalMensagem from "../../../component/base/ModalMensagem";

var debounce = require("lodash.debounce");

export function Visualizacao() {
  const token = localStorage.getItem("token") || "";

  const [answers, setAnswers]: any = useState({});

  const onchangeInput=(e:any,key:any)=>{
    if(e.target.value!='' && Number.isNaN(e.target.value)){
      return;
    }

    let answers_ = { ...answers }
    answers_[key] =e.target.value==''?'': parseInt(e.target.value)
    setAnswers(answers_)
  }



  return (
    <div className="row">
      <div className="col-12">

        <div className={"py-5 px-3"}>
          <div className={"card-body"} id="card">
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "2.0rem", color: "black" }}
            >
              Visualização e análise das informações geradas
            </h4>
            <br></br>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Explicação da heurística:
            </h4>
            <br></br>
            <p align="justify"> <strong> Essa heurística determina que o software científico deve apresentar funções que permitem o usuário visualizar a informação gerada 
              pelo software, podendo manipular a forma de exibição por meio de zoom, seleção de conteúdo para aparecer na tela e seleção por cores. Além disso, o software 
              deve apresentar funções que auxiliam na análise da veracidade das informações geradas Exemplo: Um software científico de contagem de cadeias de DNA pode apresentar 
              uma função na qual o usuário final determina qual parte da sequência quer visualizar para que esses dados aparecerem na tela para o usuário manipular;. </strong> </p>
            <p align="justify"> <strong> A heurística Visualização das informações geradas foi subdividida em dois critérios de análise, a saber: Controle da visualização 
              da informação (C1) e Análise da veracidade das informações (C2) </strong> </p>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Perguntas para avaliação:
            </h4>
            <br></br>


            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
                P1.C1) O software apresenta funções que permitam que o usuário manipule a forma de apresentação das informações? Indique o número de funções analisadas (N) 
                e o número de funções coerentes (Q). Exemplo: Possibilidade de adicionar ou retirar zoom da tela. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de funções analisadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>número de funções coerentes: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>


            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{ fontSize: 18 }} align="justify">
                P1.C2)   O software apresenta funções que auxiliem o usuário na analise das informações para atestar que os resultados gerados estão corretos? Indique o 
                número de funções que poderiam apresentar elementos (N) e o número de funções que apresentam os elementos de analise (Q). Exemplo: O software apresenta 
                uma função na qual o usuário insere um fragmento do resultado, que ele já conhece, e o software realiza a verificação desse fragmento nos resultados. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de funções que poderiam apresentar elementos:  &nbsp; </span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de funções que apresentam os elementos de analise : &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            

            <button onClick={(e) => {

            }} className="btn btn-success btn-lg w-100">
              Gerar resultado
            </button>
            <ModalMensagem/>














          </div>
        </div>
      </div>

    </div>
  );
}
